var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0349 3.55479C14.3456 2.77849 14.5385 2.82207 14.4665 3.65178L13.7204 12.2336C13.648 13.0637 14.2356 13.5346 15.0308 13.2861L20.2094 11.6678C21.005 11.419 21.3993 11.8449 21.0879 12.6233L15.1595 27.445C14.8488 28.2213 14.6559 28.1777 14.7279 27.348L15.474 18.7662C15.5464 17.9361 14.9588 17.4652 14.1636 17.7137L8.98502 19.332C8.18939 19.5808 7.79506 19.1548 8.10646 18.3764L14.0349 3.55479Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveRoute);
export default __webpack_public_path__ + "static/media/ActiveRoute.16a58272bf8bccf9eb1ba7aa4916b638.svg";
export { ForwardRef as ReactComponent };